import React from 'react';
import { useThemeContext } from '../../hook/useThemeManager';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import { isDrawerOpen } from '../../selectors/selectors';
import { BuzzBridgeJobDashboardContainer } from '../../components/ScreenContainer/BuzzBridgeContainer/BuzzBridgeJobDashboardContainer';

const BuzzBridgeDashboard = () => {
    const drawerOpen = useSelector(isDrawerOpen);
    const { device } = useThemeContext();

    return (
        <MetaTags description={`BuzzBridge`} title={`BuzzBridge | Dashboard`}>
            <Container
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    minHeight: '100vh',
                }}
                maxWidth={false}
                sx={{ marginLeft: device.isDesktop && drawerOpen ? 3 : 0 }}>
                <BuzzBridgeJobDashboardContainer />
            </Container>
        </MetaTags>
    );
};

export { BuzzBridgeDashboard };
